import { Injectable } from '@angular/core';
import { StorageEngine } from './storage-engine.interface';

@Injectable({ providedIn: 'root' })
export class BrowserStorageService implements StorageEngine {
  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
